import {
  UPDATE_CURRENT_TAB,
  START_FLOW_EXECUTION,
  STOP_FLOW_EXECUTION,
  SET_ACTIVE_FLEXLAYOUT_TAB,
  SET_SAVED_FLOW,
  FETCH_FLOW_BY_ID
} from "redux/constants/flowDesigner";

const initialState = {
  currentFlowTab: {
    status: "draft",
    isExecuting: false
  },

  activeFlexLayoutTab: null
};

const tabs = (state = initialState, { type, payload }) => {
  switch (type) {
    case UPDATE_CURRENT_TAB:
      return {
        ...state,
        currentFlowTab: { ...state.currentFlowTab, ...payload }
      };

    case START_FLOW_EXECUTION:
      return {
        ...state,
        currentFlowTab: { ...state.currentFlowTab, isExecuting: true }
      };
    case STOP_FLOW_EXECUTION:
      return {
        ...state,
        currentFlowTab: { ...state.currentFlowTab, isExecuting: false }
      };
    case SET_SAVED_FLOW:
      return {
        ...state,
        currentFlowTab: { ...state.currentFlowTab, version: payload.current_version }
      };
    case FETCH_FLOW_BY_ID:
      return {
        ...state,
        currentFlowTab: { ...state.currentFlowTab, version: payload.current_version }
      };
    case SET_ACTIVE_FLEXLAYOUT_TAB:
      return {
        ...state,
        activeFlexLayoutTab: payload
      };
  }

  return state;
};

export default tabs;
